import React from 'react';
import {PhoneNumberTextFieldWithDirtyValidation} from '../../../components/form/PhoneNumberTextField';
import {AppInput, AppPhoneInput, RowGap10} from '../styles';
import {ThirdPartyFormData} from '../types';

interface TokenFormFieldsProps {
  formData: ThirdPartyFormData;
  loading: boolean;
  emailErrorMsg: string;
  firstNameErrorMsg: string;
  lastNameErrorMsg: string;
  phoneNumberErrorMsg: string;
  onFieldChange: (field: keyof ThirdPartyFormData) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneNumberChange: (value: string | undefined) => void;
}

/**
 * Shared form fields for API token creation and editing.
 * Contains all the input fields without any submission logic.
 */
const TokenFormFields: React.FC<TokenFormFieldsProps> = ({
  formData,
  loading,
  emailErrorMsg,
  firstNameErrorMsg,
  lastNameErrorMsg,
  phoneNumberErrorMsg,
  onFieldChange,
  onPhoneNumberChange,
}) => {
  return (
    <RowGap10 container direction={'column'}>
      <AppInput
        variant='standard'
        value={formData.email}
        label={'Email'}
        name={'email'}
        type={'email'}
        onChange={onFieldChange('email')}
        placeholder={'john.jones@example.com'}
        error={!!emailErrorMsg}
        helperText={emailErrorMsg || 'Contact email for API notifications and support'}
        required
        fullWidth
        disabled={loading}
      />

      <AppInput
        variant='standard'
        value={formData.firstName}
        label={'First Name'}
        name={'firstName'}
        onChange={onFieldChange('firstName')}
        placeholder={'John'}
        error={!!firstNameErrorMsg}
        helperText={firstNameErrorMsg}
        required
        fullWidth
        disabled={loading}
      />

      <AppInput
        variant='standard'
        value={formData.lastName}
        label={'Last Name'}
        name={'lastName'}
        onChange={onFieldChange('lastName')}
        placeholder={'Jones'}
        error={!!lastNameErrorMsg}
        helperText={lastNameErrorMsg}
        required
        fullWidth
        disabled={loading}
      />

      <AppPhoneInput
        value={formData.phoneNumber}
        onChange={onPhoneNumberChange}
        inputComponent={PhoneNumberTextFieldWithDirtyValidation}
        defaultCountry={"US"}
        error={!!phoneNumberErrorMsg}
        helperText={phoneNumberErrorMsg}
        variant='standard'
        fullWidth
        required
        disabled={loading}
      />

      <AppInput
        variant='standard'
        value={formData.companyName}
        label={'Company Name'}
        name={'companyName'}
        onChange={onFieldChange('companyName')}
        placeholder={'e.g., CargoMagnet, ABC Logistics'}
        fullWidth
        disabled={loading}
      />

      <AppInput
        variant='standard'
        value={formData.description}
        label={'Description'}
        name={'description'}
        onChange={onFieldChange('description')}
        placeholder={'e.g., Depot System Integration, API Inventory Token'}
        helperText={'A descriptive name to help you identify this token'}
        fullWidth
        disabled={loading}
      />
    </RowGap10>
  );
};

export default TokenFormFields;
